import { translations as base } from '@ninox/ninox-locales';

const keys = [
    'business',
    'dontHaveAnAccount',
    'email',
    'empty',
    'emailAddress',
    'emailMissing',
    'forgotPassword',
    'forgotPasswordSuccess',
    'haveAnAccount',
    'invalidCredentials',
    'invalidUserEMail',
    'login',
    'login2',
    'loginWithGoogle',
    'matchPasswords',
    'newOldPassword',
    'newPassword',
    'next',
    'noNeedToResetPassword',
    'oldPassword',
    'op_or',
    'passHint',
    'passHintCase',
    'passHintChar',
    'passHintLen',
    'passHintNum',
    'password',
    'passwordExpired',
    'private',
    'problemsLoggingIn',
    'register',
    'repeatPassword',
    'resetPassword',
    'save',
    'signIn',
    'signUpBusinessMessage',
    'signUpHeader1_1',
    'signUpHeader1_2',
    'signUpHeader2',
    'signUpNewsletter',
    'signUpPrivacyPolicy',
    'signupWithGoogle',
    'termsDisclamer',
    'wrongPassword',
    'signUpHeader3',
    'fullName',
    'thisFieldsAreRequired',
    'company',
    'numberOfEmployees',
    'select',
    'country',
    'workPhone',
    'phoneError',
    'saveProfile',
    'switchAccount',
    'LC'
] as const;

export const translations = (Object.keys(base) as (keyof typeof base)[]).reduce(
    (acc, lang) => {
        const current = base[lang];

        acc[lang] = {} as Record<(typeof keys)[number], string>;

        for (const key of keys) {
            acc[lang][key] = current[key as keyof typeof current] as string;
        }

        return acc;
    },
    {} as Record<string, Record<(typeof keys)[number], string>>
);
